<div class="rounded-[10px] border border-malou-primary bg-malou-white p-8 pl-14 md:p-6">
    <div
        class="malou-text-34--bold md:malou-text-20--bold uppercase text-malou-text-title md:leading-tight"
        [class.font-passion-one]="!partnerTheme()"
        [style.font-family]="partnerTheme()?.titleFont ?? null"
        [innerHTML]="
            googleDiagnosticResult().rating === 5
                ? ((partnerTheme()
                      ? 'maloupe.diagnostic_result.competitors.title.rating_partner'
                      : 'maloupe.diagnostic_result.competitors.title.rating'
                  ) | translate)
                : ((partnerTheme()
                      ? 'maloupe.diagnostic_result.competitors.title.ratingCount_partner'
                      : 'maloupe.diagnostic_result.competitors.title.ratingCount'
                  ) | pluralTranslate: googleDiagnosticResult().restaurantWithHigherRatingCount)
        "></div>
    <div class="mt-12 flex w-full gap-10 md:mt-5 md:flex-col md:gap-3">
        <div class="flex w-7/12 flex-col gap-4 md:w-full">
            <div class="flex flex-col gap-4 md:gap-3">
                <div class="flex gap-3">
                    @if (partnerTheme(); as theme) {
                        <div
                            class="flex h-[75px] w-1/2 items-center justify-center overflow-hidden rounded-[5px] border border-malou-primary--light px-4 text-center"
                            [style.background-color]="theme.header.secondaryColor">
                            <span class="malou-text-13--bold leading-snug text-malou-white">{{ restaurantName() }}</span>
                        </div>
                        <div
                            class="flex h-[75px] w-1/2 items-center justify-center rounded-[5px] border border-malou-primary--light px-4 text-center"
                            [style.background-color]="theme.header.secondaryColor">
                            <span class="malou-text-13--bold text-malou-white">{{
                                'maloupe.diagnostic_result.competitors.competitors' | translate
                            }}</span>
                        </div>
                    } @else {
                        <div class="malou-custom-box w-1/2">{{ restaurantName() }}</div>
                        <div class="malou-custom-box w-1/2">{{ 'maloupe.diagnostic_result.competitors.competitors' | translate }}</div>
                    }
                </div>

                <div class="flex gap-3">
                    <ng-container
                        [ngTemplateOutlet]="restaurantGoogleRatingTemplate"
                        [ngTemplateOutletContext]="{
                            googleDiagnosticRating: googleDiagnosticRating(),
                            value: googleDiagnosticResult().rating ?? '-',
                            text: googleDiagnosticResult().rating
                                ? 'maloupe.diagnostic_result.competitors.google_rating'
                                : 'maloupe.diagnostic_result.competitors.no_google_rating',
                        }" />
                    <ng-container
                        [ngTemplateOutlet]="competitorGoogleRatingTemplate"
                        [ngTemplateOutletContext]="{
                            value: googleDiagnosticResult().averageRatingForSimilarRestaurants,
                            text: partnerTheme()
                                ? 'maloupe.diagnostic_result.competitors.average_competitors_rating_partner'
                                : 'maloupe.diagnostic_result.competitors.average_competitors_rating',
                        }" />
                </div>

                <div class="flex gap-3">
                    <ng-container
                        [ngTemplateOutlet]="restaurantGoogleRatingTemplate"
                        [ngTemplateOutletContext]="{
                            googleDiagnosticRating: googleReviewCountDiagnosticRating(),
                            value: googleDiagnosticResult().reviewCount,
                            text: 'maloupe.diagnostic_result.competitors.review_count',
                        }" />
                    <ng-container
                        [ngTemplateOutlet]="competitorGoogleRatingTemplate"
                        [ngTemplateOutletContext]="{
                            value: googleDiagnosticResult().averageReviewCountForSimilarRestaurants,
                            text: partnerTheme()
                                ? 'maloupe.diagnostic_result.competitors.average_competitors_review_count_partner'
                                : 'maloupe.diagnostic_result.competitors.average_competitors_review_count',
                        }" />
                </div>
            </div>
        </div>
        @if (partnerTheme(); as theme) {
            <div
                class="flex w-1/2 flex-col items-center justify-center gap-6 rounded-[5px] border border-malou-primary bg-malou-white px-16 md:w-full md:gap-4 md:px-5">
                <img class="partner-score-card__gimmick" alt="" [src]="'logo' | logoPathResolver: { folder: 'partners' }" />
                @if (theme.competitorsIllustrationPath) {
                    <img class="w-[15%] md:w-16" alt="" [src]="theme.competitorsIllustrationPath" />
                }
                <div class="malou-text-26--bold text-center leading-[1.2] text-malou-text-title">
                    {{ 'maloupe.diagnostic_result.competitors.improve_rating' | translate }}
                </div>
                <button
                    class="malou-text-16--regular rounded-[5px] px-6 py-3 text-malou-white"
                    [style.background-color]="theme.ctaColor ?? theme.header.primaryColor"
                    (click)="redirectToReviewCalculator()">
                    {{ 'maloupe.diagnostic_result.competitors.review_calculator' | translate }}
                </button>
            </div>
        } @else {
            <div
                class="flex w-1/2 flex-col items-center justify-center gap-6 rounded-xl bg-malou-primary--light px-16 md:w-full md:gap-4 md:px-5">
                <img class="w-[30%] md:w-28" [src]="Illustration.BINOCULARS | illustrationPathResolver" />
                <div class="malou-text-30--bold md:malou-text-24--bold text-center text-malou-text-title md:leading-none">
                    {{ 'maloupe.diagnostic_result.competitors.improve_rating' | translate }}
                </div>
                <button
                    class="text-malou-16--regular rounded-full bg-malou-blue px-8 py-3 text-malou-white md:mb-5"
                    (click)="redirectToReviewCalculator()">
                    {{ 'maloupe.diagnostic_result.competitors.review_calculator' | translate }}
                </button>
            </div>
        }
    </div>
    @if (!partnerTheme()) {
        <div class="mt-6 flex items-center rounded-[10px] bg-malou-dark px-8 py-3 md:gap-3 md:px-3">
            <img class="mr-7 w-12 sm:!h-8 md:h-fit md:w-9" [alt]="Icon.TRUMPET" [src]="Icon.TRUMPET | imagePathResolver" />
            <span
                class="malou-text-12--regular mr-1 text-malou-text-title"
                [innerHTML]="'maloupe.diagnostic_result.competitors.indication' | translate">
            </span>
            <a
                class="malou-text-12--regular italic text-malou-text-title underline"
                target="_blank"
                [href]="isEnglish() ? EXPERT_DIAGNOSTIC_QUICK_CALL_EN : EXPERT_DIAGNOSTIC_QUICK_CALL_FR">
                {{ 'maloupe.diagnostic_result.competitors.indication_action' | translate }}
            </a>
        </div>
    }
</div>

<ng-template let-googleDiagnosticRating="googleDiagnosticRating" let-value="value" let-text="text" #restaurantGoogleRatingTemplate>
    <div
        class="flex min-h-40 w-1/2 flex-col rounded-[5px] p-4 pl-5 md:items-stretch md:gap-4 md:p-3"
        [ngClass]="{
            'bg-malou-pink/5': googleDiagnosticRating === DiagnosticRating.BAD,
            'border border-malou-primary bg-malou-white': googleDiagnosticRating !== DiagnosticRating.BAD,
        }">
        <div class="flex justify-end md:justify-start">
            <app-rating-chip [diagnosticRating]="googleDiagnosticRating"></app-rating-chip>
        </div>
        <div class="flex h-full flex-col justify-end pb-4">
            <span class="malou-text-40--bold leading-10">{{ value }}</span>
            <span class="malou-text-12--medium text-malou-text">
                {{ text | translate }}
            </span>
        </div>
    </div>
</ng-template>

<ng-template let-value="value" let-text="text" #competitorGoogleRatingTemplate>
    <div class="flex min-h-40 w-1/2 gap-5 rounded-[5px] border border-malou-primary bg-malou-white md:items-stretch">
        <div
            class="flex w-[55px] shrink-0 items-center justify-center rounded-bl-[5px] rounded-tl-[5px] border-r border-malou-primary md:hidden"
            [class.bg-malou-dark]="!partnerTheme()"
            [class.bg-[#eeede9]]="!!partnerTheme()">
            @if (partnerTheme()) {
                <span class="text-[30px] leading-none">✨</span>
            } @else {
                <img class="w-[60px]" alt="stars" [src]="'stars' | imagePathResolver" />
            }
        </div>
        <div class="flex h-full flex-col justify-end p-3 pb-5 md:gap-2 md:py-4">
            <span class="malou-text-40--bold leading-10">
                {{ value }}
            </span>
            <span class="malou-text-12--medium text-malou-text">
                {{ text | translate }}
            </span>
        </div>
    </div>
</ng-template>
